namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsShopDialog extends Serenity.EntityDialog<PsShopRow, any> {
        protected getFormKey() { return PsShopForm.formKey; }
        protected getIdProperty() { return PsShopRow.idProperty; }
        protected getLocalTextPrefix() { return PsShopRow.localTextPrefix; }
        protected getNameProperty() { return PsShopRow.nameProperty; }
        protected getService() { return PsShopService.baseUrl; }
        protected getDeletePermission() { return PsShopRow.deletePermission; }
        protected getInsertPermission() { return PsShopRow.insertPermission; }
        protected getUpdatePermission() { return PsShopRow.updatePermission; }

        protected form = new PsShopForm(this.idPrefix);


        constructor() {
            super();
            if (this.isNew) {
                this.form.ShopRegAddressLine1.changeSelect2(e => {
                    var shopadd = Q.toId(this.form.ShopRegAddressLine1.value);

                    if (shopadd != null) {


                        this.form.ShopAddress.value = this.form.ShopRegAddressLine1.value + this.form.ShopRegAddressLine2.value + this.form.ShopRegAddressLine3.value;


                    }
                });
                this.form.ShopRegAddressLine2.changeSelect2(e => {
                    var shopadd2 = Q.toId(this.form.ShopRegAddressLine2.value);
                    if (shopadd2 != null) {


                        this.form.ShopAddress.value = this.form.ShopRegAddressLine1.value + this.form.ShopRegAddressLine2.value + this.form.ShopRegAddressLine3.value;


                    }
                });
                this.form.ShopRegAddressLine3.changeSelect2(e => {
                    var shopadd3 = Q.toId(this.form.ShopRegAddressLine3.value);
                    if (shopadd3 != null) {


                        this.form.ShopAddress.value = this.form.ShopRegAddressLine1.value + this.form.ShopRegAddressLine2.value + this.form.ShopRegAddressLine3.value;


                    }
                });
            }


          

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();

            var user = Q.tryFirst(Lookups.VwUserRow.getLookup().items, x => x.ShopId == this.entity.ShopId);
            if (user != null) {
                this.deleteButton.toggleClass('disabled', true);                
            }
            

            var Shopid = Q.tryFirst(IcWhsRow.getLookup().items, x => x.ShopId == this.entity.ShopId);
            if (Shopid != null) {
                this.deleteButton.toggleClass('disabled', true);

            }

            if (this.isNew()) {
                let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)
                // this.form.ShopAddress.value = p.ShopAddress;
                this.form.ShopRegName.value = p.ShopRegName;
                this.form.ShopRegAddressLine1.value = p.ShopRegAddressLine1;
                this.form.ShopRegAddressLine2.value = p.ShopRegAddressLine2;
                this.form.ShopRegAddressLine3.value = p.ShopRegAddressLine3;
                this.form.ShopRegId.value = p.ShopRegId;
                this.form.ShopTaxId.value = p.ShopTaxId;
                this.form.PromptPayLink.value = p.PromptPayLink;
                this.form.QRCodeAccount.value = p.QrCodeAccount;
            }


        }

    }
}


